import { __name } from './chunk-SHUYVCID.js';
import { attendantGenderTransgender, attendantGenderFemale, attendantGenderMale, attendantMediaVisibilityPublic, attendantMediaVisibilityPrivate, attendantSexualOrientationHomosexual, attendantSexualOrientationHetero, attendantSexualOrientationBisexual, attendantGosShowerBathgames, attendantGosFingering, attendantGosFacesitting, attendantGosGoldenShowerActive, attendantGosFrenchKissing, attendantGosStriptease, attendantGosSaferSex, attendantGosRolePlay, attendantGosRimmingPassive, attendantGosRimmingActive, attendantGosProstateMassage, attendantGosPegging, attendantGosKissing, attendantGosSnuggling, attendantGosBodyCumshot, attendantGosHandjob, attendantGosFacialCumshot, attendantGosFootWorship, attendantGosNaughtyNightOut, attendantGosFistingPassive, attendantGosBondageActive, attendantGosEroticMassage, attendantGosBallLicking, attendantGosDirtyTalk, attendantGosDeepthroat, attendantGosCunnilingus, attendantGosBoobJob, attendantGosBlowjob, attendantGosAnalSex, attendantGosPosition69, attendantNoCustomerDisabilities, attendantNoCustomerGentlemen80, attendantNoCustomerGentlemen70, attendantNoCustomerGentlemen60, attendantNoCustomerSmoker, attendantToyStrapOn, attendantToyButtPlug, attendantToyAnalBeads, attendantToyElectrostimulationToy, attendantToyDildo, attendantToyVibrator, attendantToyLeatherOutfit, attendantToyLatexOutfit, attendantToyVinylOutfit, attendantThreesomeEscortDescription, attendantThreesomeEscort, attendantThreesomeEscortBisexualDescription, attendantThreesomeEscortBisexual, attendantThreesomeMMFDescription, attendantThreesomeMMF, attendantThreesomeFFMDescription, attendantThreesomeFFM, attendantActivityYoga, attendantActivityTrekking, attendantActivityTennis, attendantActivityDiving, attendantActivityDancing, attendantActivitySnowboard, attendantActivitySkiing, attendantActivitySwimming, attendantActivitySnorkeling, attendantActivityIceSkating, attendantActivityHorse, attendantActivityMotorBike, attendantActivityHiking, attendantActivityJogging, attendantActivityGolf, attendantActivityAerobic, attendantFoodTurkish, attendantFoodSushi, attendantFoodSpanish, attendantFoodMexican, attendantFoodMediterranean, attendantFoodItalian, attendantFoodIndian, attendantFoodGreek, attendantFoodFrench, attendantFoodGerman, attendantFoodChinese, attendantFoodAsian, attendantFoodAmerican, attendantDrinkJuices, attendantDrinkSoftDrinks, attendantDrinkSparklingWater, attendantDrinkStillWater, attendantDrinkCocktails, attendantDrinkBeer, attendantDrinkSparklingWine, attendantDrinkProsecco, attendantDrinkChampagne, attendantDrinkRedWine, attendantDrinkSweetWhiteWine, attendantDrinkDryWhiteWine, attendantJobHousewife, attendantJobPartTimeEmployee, attendantJobCeo, attendantJobFreelancer, attendantJobEmployee, attendantJobIntern1, attendantJobTrainee, attendantJobIntern, attendantJobStudent, attendantJobPupil, attendantMobilityCarsharing, attendantMobilityPublic, attendantMobilityCar, attendantNutritionVegan, attendantNutritionVegetarian, attendantNutritionMeat, attendantGiftPerfume, attendantGiftDessous, attendantGiftFlowers, attendantGiftChocolates, attendantSmokerStrictNonSmoker, attendantSmokerNonSmoker, attendantSmokerCasual, attendantSmokerActive, attendantIntimaPartShaved, attendantIntimaUnshaved, attendantIntimaShaved, attendantTattooEverywhere, attendantTattooHuge, attendantTattooLargeMultiple, attendantTattooLarge, attendantTattooMediumMultiple, attendantTattooMedium, attendantTattooSmallMultiple, attendantTattooSmall, attendantTattooNone, attendantPiercingCheek, attendantPiercingNasalSeptum, attendantPiercingGenital, attendantPiercingNipple, attendantPiercingTongue, attendantPiercingLips, attendantPiercingEyebrow, attendantPiercingNostril, attendantPiercingBellyButton, attendantFitnessLevelNone, attendantFitnessLevelCasual, attendantFitnessLevelActive, attendantFitnessLevelHighlyActive, attendantVisitHotelVisits, attendantVisitSwingerClubs, attendantVisitHouseVisits, crudStatesStatusRegistered, crudStatesStatusRejected, crudStatesStatusOnboarded, crudStatesStatusOnOnboarding, crudStatesStatusOnVerified, crudStatesStatusOnVerification, crudStatesStatusBlocked, crudStatesStatusApproved, crudStatesStatusInactive, attendantTypeHostess, attendantTypeEscort, attendantFilterTravelCompanion } from '@bells/i18n';
import { Gender, AttendantVisibility, SexualOrientation, Gos, NoCustomer, Toy, ThreesomeStatus, Activity, FoodPreference, DrinkPreference, JobPosition, MobilityStatus, NutritionStatus, Gift, SmokerStatus, IntimaZone, Tattoo, Piercing, FitnessLevel, VisitStatus, AttendantProfileState, AttendantType } from '@bells/schema/models/attendant';

const Genders = {
  [Gender.MALE]: attendantGenderMale(),
  [Gender.FEMALE]: attendantGenderFemale(),
  [Gender.TRANSGENDER]: attendantGenderTransgender()
};
const AttendantVisibilities = {
  [AttendantVisibility.PRIVATE]: attendantMediaVisibilityPrivate(),
  [AttendantVisibility.PUBLIC]: attendantMediaVisibilityPublic()
};
const SexualOrientations = /* @__PURE__ */ __name((language) => {
  return {
    [SexualOrientation.BISEXUAL]: attendantSexualOrientationBisexual(language),
    [SexualOrientation.HETERO]: attendantSexualOrientationHetero(language),
    [SexualOrientation.HOMOSEXUAL]: attendantSexualOrientationHomosexual(language)
  };
}, "SexualOrientations");
const GosStatuses = /* @__PURE__ */ __name((language) => {
  return {
    [Gos.POSITION_69]: attendantGosPosition69(language),
    [Gos.ANAL_SEX]: attendantGosAnalSex(language),
    [Gos.BLOWJOB]: attendantGosBlowjob(language),
    [Gos.BOOB_JOB]: attendantGosBoobJob(language),
    [Gos.CUNNILINGUS]: attendantGosCunnilingus(language),
    [Gos.DEEPTHROAT]: attendantGosDeepthroat(language),
    [Gos.DIRTY_TALK]: attendantGosDirtyTalk(language),
    [Gos.BALL_LICKING]: attendantGosBallLicking(language),
    [Gos.EROTIC_MASSAGE]: attendantGosEroticMassage(language),
    [Gos.BONDAGE_ACTIVE]: attendantGosBondageActive(language),
    [Gos.FISTING_PASSIVE]: attendantGosFistingPassive(language),
    [Gos.NAUGHTY_NIGHT_OUT]: attendantGosNaughtyNightOut(language),
    [Gos.FOOT_WORSHIP]: attendantGosFootWorship(language),
    [Gos.FACIAL_CUMSHOT]: attendantGosFacialCumshot(language),
    [Gos.HANDJOB]: attendantGosHandjob(language),
    [Gos.BODY_CUMSHOT]: attendantGosBodyCumshot(language),
    [Gos.SNUGGLING]: attendantGosSnuggling(language),
    [Gos.KISSING]: attendantGosKissing(language),
    [Gos.PEGGING]: attendantGosPegging(language),
    [Gos.PROSTATE_MASSAGE]: attendantGosProstateMassage(language),
    [Gos.RIMMING_ACTIVE]: attendantGosRimmingActive(language),
    [Gos.RIMMING_PASSIVE]: attendantGosRimmingPassive(language),
    [Gos.ROLE_PLAY]: attendantGosRolePlay(language),
    [Gos.SAFER_SEX]: attendantGosSaferSex(language),
    [Gos.STRIPTEASE]: attendantGosStriptease(language),
    [Gos.FRENCH_KISSING]: attendantGosFrenchKissing(language),
    [Gos.GOLDEN_SHOWER_ACTIVE]: attendantGosGoldenShowerActive(language),
    [Gos.FACESITTING]: attendantGosFacesitting(language),
    [Gos.FINGERING]: attendantGosFingering(language),
    [Gos.SHOWER_BATHGAMES]: attendantGosShowerBathgames(language)
  };
}, "GosStatuses");
const NoCustomerStatuses = /* @__PURE__ */ __name((language) => {
  return {
    [NoCustomer.SMOKER]: attendantNoCustomerSmoker(language),
    [NoCustomer.GENTLEMEN60]: attendantNoCustomerGentlemen60(language),
    [NoCustomer.GENTLEMEN70]: attendantNoCustomerGentlemen70(language),
    [NoCustomer.GENTLEMEN80]: attendantNoCustomerGentlemen80(language),
    [NoCustomer.INDIVIDUALSDISABILITIES]: attendantNoCustomerDisabilities(language)
  };
}, "NoCustomerStatuses");
const Toys = /* @__PURE__ */ __name((language) => {
  return {
    [Toy.VINYL_OUTFIT]: attendantToyVinylOutfit(language),
    [Toy.LATEX_OUTFIT]: attendantToyLatexOutfit(language),
    [Toy.LEATHER_OUTFIT]: attendantToyLeatherOutfit(language),
    [Toy.VIBRATOR]: attendantToyVibrator(language),
    [Toy.DILDO]: attendantToyDildo(language),
    [Toy.STIMULATION_TOY]: attendantToyElectrostimulationToy(language),
    [Toy.ANAL_BEADS]: attendantToyAnalBeads(language),
    [Toy.BUT_PLUG]: attendantToyButtPlug(language),
    [Toy.STRAP_ON]: attendantToyStrapOn(language)
  };
}, "Toys");
const ThreesomeStatuses = /* @__PURE__ */ __name((language) => {
  return [
    {
      value: ThreesomeStatus.ESCORT_PARTNER_BISEXUAL,
      label: attendantThreesomeEscort(language),
      description: attendantThreesomeEscortDescription(language)
    },
    {
      value: ThreesomeStatus.ESCORT_PARTNER_HETERO,
      label: attendantThreesomeEscortBisexual(language),
      description: attendantThreesomeEscortBisexualDescription(language)
    },
    {
      value: ThreesomeStatus.MMF,
      label: attendantThreesomeMMF(language),
      description: attendantThreesomeMMFDescription(language)
    },
    {
      value: ThreesomeStatus.FFM,
      label: attendantThreesomeFFM(language),
      description: attendantThreesomeFFMDescription(language)
    }
  ];
}, "ThreesomeStatuses");
const Activities = /* @__PURE__ */ __name((language) => {
  return {
    [Activity.AEROBIC]: attendantActivityAerobic(language),
    [Activity.GOLF]: attendantActivityGolf(language),
    [Activity.JOGGING]: attendantActivityJogging(language),
    [Activity.HIKING]: attendantActivityHiking(language),
    [Activity.MOTORBIKE]: attendantActivityMotorBike(language),
    [Activity.HORSE]: attendantActivityHorse(language),
    [Activity.ICE_SKATING]: attendantActivityIceSkating(language),
    [Activity.SNORKELING]: attendantActivitySnorkeling(language),
    [Activity.SWIMMING]: attendantActivitySwimming(language),
    [Activity.SKIING]: attendantActivitySkiing(language),
    [Activity.SNOWBOARDING]: attendantActivitySnowboard(language),
    [Activity.DANCING]: attendantActivityDancing(language),
    [Activity.DIVING]: attendantActivityDiving(language),
    [Activity.TENNIS]: attendantActivityTennis(language),
    [Activity.TREKKING]: attendantActivityTrekking(language),
    [Activity.YOGA]: attendantActivityYoga(language)
  };
}, "Activities");
const FoodPreferences = /* @__PURE__ */ __name((language) => {
  return {
    [FoodPreference.AMERICAN]: attendantFoodAmerican(language),
    [FoodPreference.ASIAN]: attendantFoodAsian(language),
    [FoodPreference.CHINESE]: attendantFoodChinese(language),
    [FoodPreference.GERMAN]: attendantFoodGerman(language),
    [FoodPreference.FRENCH]: attendantFoodFrench(language),
    [FoodPreference.GREEK]: attendantFoodGreek(language),
    [FoodPreference.INDIAN]: attendantFoodIndian(language),
    [FoodPreference.ITALIAN]: attendantFoodItalian(language),
    [FoodPreference.MEDITERRANEAN]: attendantFoodMediterranean(language),
    [FoodPreference.MEXICAN]: attendantFoodMexican(language),
    [FoodPreference.SPANISH]: attendantFoodSpanish(language),
    [FoodPreference.SUSHI]: attendantFoodSushi(language),
    [FoodPreference.TURKISH]: attendantFoodTurkish(language)
  };
}, "FoodPreferences");
const DrinkPreferences = /* @__PURE__ */ __name((language) => {
  return {
    [DrinkPreference.DRY_WHITE_WINE]: attendantDrinkDryWhiteWine(language),
    [DrinkPreference.SWEET_WHITE_WINE]: attendantDrinkSweetWhiteWine(language),
    [DrinkPreference.RED_WINE]: attendantDrinkRedWine(language),
    [DrinkPreference.CHAMPAGNE]: attendantDrinkChampagne(language),
    [DrinkPreference.PROSECCO]: attendantDrinkProsecco(language),
    [DrinkPreference.SPARKLING_WINE]: attendantDrinkSparklingWine(language),
    [DrinkPreference.BEER]: attendantDrinkBeer(language),
    [DrinkPreference.COCKTAILS]: attendantDrinkCocktails(language),
    [DrinkPreference.STILL_WATER]: attendantDrinkStillWater(language),
    [DrinkPreference.SPARKLING_WATER]: attendantDrinkSparklingWater(language),
    [DrinkPreference.SOFT_DRINKS]: attendantDrinkSoftDrinks(language),
    [DrinkPreference.JUICES]: attendantDrinkJuices(language)
  };
}, "DrinkPreferences");
const JobPositions = /* @__PURE__ */ __name((language) => {
  return {
    [JobPosition.PUPIL]: attendantJobPupil(language),
    [JobPosition.STUDENT]: attendantJobStudent(language),
    [JobPosition.STUDENT_WORK]: attendantJobIntern(language),
    [JobPosition.TRAINEE]: attendantJobTrainee(language),
    [JobPosition.INTERNSHIP]: attendantJobIntern1(language),
    [JobPosition.EMPLOYEE]: attendantJobEmployee(language),
    [JobPosition.FREELANCER]: attendantJobFreelancer(language),
    [JobPosition.CEO]: attendantJobCeo(language),
    [JobPosition.PART_TIME]: attendantJobPartTimeEmployee(language),
    [JobPosition.HOUSEWIFE]: attendantJobHousewife(language)
  };
}, "JobPositions");
const MobilityStatuses = /* @__PURE__ */ __name((language) => {
  return {
    [MobilityStatus.CAR]: attendantMobilityCar(language),
    [MobilityStatus.PUBLIC]: attendantMobilityPublic(language),
    [MobilityStatus.CARSHARING]: attendantMobilityCarsharing(language)
  };
}, "MobilityStatuses");
const NutritionStatuses = /* @__PURE__ */ __name((language) => {
  return {
    [NutritionStatus.MEAT]: attendantNutritionMeat(language),
    [NutritionStatus.VEGETARIAN]: attendantNutritionVegetarian(language),
    [NutritionStatus.BEGAN]: attendantNutritionVegan(language)
  };
}, "NutritionStatuses");
const Gifts = /* @__PURE__ */ __name((language) => {
  return {
    [Gift.CHOCOLATES]: attendantGiftChocolates(language),
    [Gift.FLOWERS]: attendantGiftFlowers(language),
    [Gift.DESSOUS]: attendantGiftDessous(language),
    [Gift.PERFUME]: attendantGiftPerfume(language)
  };
}, "Gifts");
const SmokerStatuses = /* @__PURE__ */ __name((language) => {
  return {
    [SmokerStatus.ACTIVE]: attendantSmokerActive(language),
    [SmokerStatus.CASUAL]: attendantSmokerCasual(language),
    [SmokerStatus.NONE_SMOKER]: attendantSmokerNonSmoker(language),
    [SmokerStatus.STRICT_NONE]: attendantSmokerStrictNonSmoker(language)
  };
}, "SmokerStatuses");
const IntimaZones = /* @__PURE__ */ __name((language) => {
  return {
    [IntimaZone.SHAVED]: attendantIntimaShaved(language),
    [IntimaZone.UNSHAVED]: attendantIntimaUnshaved(language),
    [IntimaZone.PART_SHAVED]: attendantIntimaPartShaved(language)
  };
}, "IntimaZones");
const Tattoos = /* @__PURE__ */ __name((language) => {
  return {
    [Tattoo.NONE]: attendantTattooNone(language),
    [Tattoo.SMALL]: attendantTattooSmall(language),
    [Tattoo.SMALL_MULTIPLE]: attendantTattooSmallMultiple(language),
    [Tattoo.MEDIUM]: attendantTattooMedium(language),
    [Tattoo.MEDIUM_MULTIPLE]: attendantTattooMediumMultiple(language),
    [Tattoo.LARGE]: attendantTattooLarge(language),
    [Tattoo.LARGE_MULTIPLE]: attendantTattooLargeMultiple(language),
    [Tattoo.HUGE]: attendantTattooHuge(language),
    [Tattoo.EVERYWHERE]: attendantTattooEverywhere(language)
  };
}, "Tattoos");
const Piercings = /* @__PURE__ */ __name((language) => {
  return {
    [Piercing.BELLY_BUTTON]: attendantPiercingBellyButton(language),
    [Piercing.NOSTRIL]: attendantPiercingNostril(language),
    [Piercing.EYEBROW]: attendantPiercingEyebrow(language),
    [Piercing.LIPS]: attendantPiercingLips(language),
    [Piercing.TONGUE]: attendantPiercingTongue(language),
    [Piercing.NIPPLE]: attendantPiercingNipple(language),
    [Piercing.GENITAL]: attendantPiercingGenital(language),
    [Piercing.NASAL_SEPTUM]: attendantPiercingNasalSeptum(language),
    [Piercing.CHEEK]: attendantPiercingCheek(language)
  };
}, "Piercings");
const HairColorHexMap = {
  DARK_BLOND: "#b89778",
  BLOND: "#f7e7b4",
  BLACK: "#000000",
  GRAY: "#808080",
  SILVER: "#c0c0c0",
  RED: "#b30000",
  BROWN: "#8b4513",
  MULTI_COLOR: "linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)"
};
const FitnessLevels = /* @__PURE__ */ __name((language) => {
  return {
    [FitnessLevel.HIGHLY_ACTIVE]: attendantFitnessLevelHighlyActive(language),
    [FitnessLevel.ACTIVE]: attendantFitnessLevelActive(language),
    [FitnessLevel.CASUAL]: attendantFitnessLevelCasual(language),
    [FitnessLevel.NONE]: attendantFitnessLevelNone(language)
  };
}, "FitnessLevels");
const VisitStatuses = /* @__PURE__ */ __name((language) => {
  return {
    [VisitStatus.HOUSE_VISITS]: attendantVisitHouseVisits(language),
    [VisitStatus.SWINGER_CLUBS]: attendantVisitSwingerClubs(language),
    [VisitStatus.HOTEL_VISITS]: attendantVisitHotelVisits(language)
  };
}, "VisitStatuses");
const AttendantProfileStates = /* @__PURE__ */ __name((language) => {
  return {
    [AttendantProfileState.INACTIVE]: crudStatesStatusInactive(language),
    [AttendantProfileState.APPROVED]: crudStatesStatusApproved(language),
    [AttendantProfileState.BLOCKED]: crudStatesStatusBlocked(language),
    [AttendantProfileState.ON_VERIFICATION]: crudStatesStatusOnVerification(language),
    [AttendantProfileState.VERIFIED]: crudStatesStatusOnVerified(language),
    [AttendantProfileState.ON_ONBOARDING]: crudStatesStatusOnOnboarding(language),
    [AttendantProfileState.ONBOARDED]: crudStatesStatusOnboarded(language),
    [AttendantProfileState.REJECTED]: crudStatesStatusRejected(language),
    [AttendantProfileState.REGISTERED]: crudStatesStatusRegistered(language)
  };
}, "AttendantProfileStates");
const AttendantTypes = /* @__PURE__ */ __name((language) => {
  return {
    [AttendantType.ESCORT]: attendantTypeEscort(language),
    [AttendantType.HOSTESS]: attendantTypeHostess(language)
  };
}, "AttendantTypes");
const TravelCompanion = /* @__PURE__ */ __name((language) => {
  return attendantFilterTravelCompanion(language);
}, "TravelCompanion");

export { Activities, AttendantProfileStates, AttendantTypes, AttendantVisibilities, DrinkPreferences, FitnessLevels, FoodPreferences, Genders, Gifts, GosStatuses, HairColorHexMap, IntimaZones, JobPositions, MobilityStatuses, NoCustomerStatuses, NutritionStatuses, Piercings, SexualOrientations, SmokerStatuses, Tattoos, ThreesomeStatuses, Toys, TravelCompanion, VisitStatuses };
